var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debugModes } from '../helpers/debug';
import { docReady } from '../helpers/doc-ready';
import { getStores, setGeolocationDataAsync } from '../helpers/localization';
const regionSelector = () => __awaiter(void 0, void 0, void 0, function* () {
    const regionDrawer = document.querySelectorAll('[data-localization-selector-drawer]');
    regionDrawer.forEach((drawer) => {
        const drawerContent = drawer.querySelector('.body');
        if (drawerContent) {
            const allowedRegionsString = document.body.getAttribute('data-store-regions');
            const allowedRegionsArr = allowedRegionsString.split(',');
            let allowedRegionsArrLength;
            if (allowedRegionsArr[0] != '') {
                allowedRegionsArrLength = allowedRegionsArr.length;
            }
            else {
                allowedRegionsArrLength = 0;
            }
            let stores = [];
            if (window.thDebug.isEnabled(debugModes.geolocation)) {
                stores = getStores();
            }
            else {
                stores = getStores().filter((store) => store.enabled);
            }
            stores.forEach((store) => {
                const container = document.createElement('div');
                const title = document.createElement('h2');
                const form = document.createElement('form');
                container.setAttribute('class', 'localization__region');
                container.setAttribute('data-region', store.name);
                container.style.display = 'none';
                title.innerText = store.name;
                form.setAttribute('class', 'localization-region__list');
                form.setAttribute('method', 'post');
                form.setAttribute('action', `https://${store.primary_domain}/localization`);
                form.setAttribute('id', 'loalization-form-footer');
                form.innerHTML = `
        <input type="hidden" name="form_type" value="localization">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="_method" value="put">
        <input type="hidden" name="return_to" value="${`https://${store.primary_domain}/?m=1`}">
      `;
                store.availableCountries
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .forEach((country) => {
                    const enabledRegion = allowedRegionsArr.includes(country.isoCode);
                    if (allowedRegionsArrLength == 0 || (allowedRegionsArrLength > 0 && enabledRegion)) {
                        container.style.display = '';
                        const button = document.createElement('button');
                        button.setAttribute('class', 'region__item');
                        button.setAttribute('type', 'submit');
                        button.setAttribute('name', 'country_code');
                        button.setAttribute('value', country.isoCode);
                        button.innerHTML = `
              <div class="country-flags country-flags--${country.isoCode}"></div>
              <div class="country-name">
                <p>${country.name} (${country.currency.isoCode} ${country.currency.symbol})</p>
              </div>
            `;
                        form.appendChild(button);
                    }
                });
                container.appendChild(title);
                container.appendChild(form);
                drawerContent.appendChild(container);
            });
        }
    });
});
docReady(() => __awaiter(void 0, void 0, void 0, function* () {
    yield setGeolocationDataAsync();
    regionSelector();
}));
